// Template Generated by DataExtraction.py at 1716507313

import SKYCMaternity2English from "../../Forms/SKYC/SKYC-Maternity2English.png";
import SKYCMaternity2EnglishLabels from "../../Labels/SKYC/SKYC-Maternity2English.json";
import SKYCMaternity2French from "../../Forms/SKYC/SKYC-Maternity2French.png";
import SKYCMaternity2FrenchLabels from "../../Labels/SKYC/SKYC-Maternity2French.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab, drawText as drawTextAtPos
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import moment from "moment/moment";
import {
    calculateMaxEducationSavingsPlans, calculateMonthlyDisposableIncome, calculateMonthlyDisposableIncomeAfterMat,
    calculateTotalMonthlyExpenses, calculateTotalMonthlyExpensesAfterMat, isDisposableIncomeExceeded,
    isKnowYourClientFormComplete
} from "../../../Utils/KYCUtils";
import { t } from "i18next";
import { displayCurrency } from "../../../Utils/FormattingUtils";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? SKYCMaternity2FrenchLabels : SKYCMaternity2EnglishLabels;
    const formImage = isFrench ? SKYCMaternity2French : SKYCMaternity2English;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label, colorOverride = null, bold = false) {
        drawTextOnLabel(doc, value, label, labels, colorOverride, bold);
    }

    function drawLongText(value, label) {
        drawTextOnLabel(doc, value, label, labels, null, false, true);
    }

    // add image
    ///doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);
    const Y_OFFSET = 7; // You can adjust this to 10, 30, etc., as needed

doc.addImage(
    formImage,
    standardFormFormat,
    labels["image"]["x"],
    labels["image"]["y"] + Y_OFFSET,
    labels["image"]["width"],
    labels["image"]["height"],
    null,
    standardFormCompression
);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;
    const common = data.common;
    const kyc = data.knowYourClient;
    const plan = data.plan;

    const planTypeID = plan.planTypeID;

    const subscriber2Include = common.subscriber2Include;

    const dateFormat = "yyyy-MM-DD";

    const now = moment().format(dateFormat);

    const planTypeMappings = {
        "-1": "",
        0: "Group",
        1: "Self-Initiated",
        2: "Achievers",
    }

    const planType = planTypeMappings[planTypeID];

    const {
        monthlyMaximumEducationSavingsPlan,
        monthlyMaximumEducationSavingsPlanGroup
    } = calculateMaxEducationSavingsPlans(subscriber, jointSubscriber, kyc);

    // Drawing the form
    if (planTypeID === 0) { // Group
        drawText("(H)", "affordabilityGroup", null, true);
    } else if (planTypeID === 1) { // Self-Initiated
        // drawText("affordabilitySelfInitiated", "affordabilitySelfInitiated"); // doesn't exist
    } else if (planTypeID === 2) { // Achievers
        drawText("(H)", "affordabilityAchievers", null, true);
    }

    drawText(displayCurrency(kyc.childCare, i18n.language), "childCare");
    drawText(displayCurrency(kyc.childCareAfterMat, i18n.language), "childCareAfterMat");
    drawText(displayCurrency(kyc.clothing, i18n.language), "clothing");
    drawText(displayCurrency(kyc.clothingAfterMat, i18n.language), "clothingAfterMat");
    drawText(isDisposableIncomeExceeded(subscriber, jointSubscriber, kyc) ? t("Disposable Income Exceeded") : "", "diExceeded", isDisposableIncomeExceeded(subscriber, jointSubscriber, kyc) ? {
        r: 255,
        g: 0,
        b: 0,
        a: 255
    } : null);
    drawText(displayCurrency(calculateMonthlyDisposableIncome(subscriber, jointSubscriber, kyc), i18n.language), "disposableIncome");
    drawText(displayCurrency(calculateMonthlyDisposableIncomeAfterMat(subscriber, jointSubscriber, kyc), i18n.language), "disposableIncomeAfterMat");
    drawText(now, "drDate");

    if (!isKnowYourClientFormComplete(subscriber, jointSubscriber, kyc, common)) {
        drawText(t("Form Incomplete"), "formIncomplete", {
            r: 255,
            g: 0,
            b: 0,
            a: 255
        });
    }
    drawText(displayCurrency(kyc.groceries, i18n.language), "groceries");
    drawText(displayCurrency(kyc.groceriesAfterMat, i18n.language), "groceriesAfterMat");
    drawText(displayCurrency(kyc.insurance, i18n.language), "insurance");
    drawText(displayCurrency(kyc.insuranceAfterMat, i18n.language), "insuranceAfterMat");
    drawText(displayCurrency(monthlyMaximumEducationSavingsPlan, i18n.language), "maximumEsp", null, true);
    drawText(displayCurrency(monthlyMaximumEducationSavingsPlanGroup, i18n.language), "maximumEspGroup", null, true);
    drawText(displayCurrency(kyc.miscellaneous, i18n.language), "miscellaneous");
    drawText(displayCurrency(kyc.miscellaneousAfterMat, i18n.language), "miscellaneousAfterMat");
    drawText(displayCurrency(kyc.morgageCondoFeesRent, i18n.language), "mortgage");
    drawText(displayCurrency(kyc.morgageCondoFeesRentAfterMat, i18n.language), "mortgageAfterMat");
    drawLongText(kyc.notes, "notes");
    drawText(displayCurrency(kyc.otherContractualObligations, i18n.language), "otherContractualObligations");
    drawText(displayCurrency(kyc.otherContractualObligationsAfterMat, i18n.language), "otherContractualObligationsAfterMat");
    drawText(displayCurrency(kyc.paymentOnLoansAndDebts, i18n.language), "paymentsOnLoansAndDebts");
    drawText(displayCurrency(kyc.paymentOnLoansAndDebtsAfterMat, i18n.language), "paymentsOnLoansAndDebtsAfterMat");
    drawText(now, "s1Date");
    if (subscriber2Include) {
        drawText(now, "s2Date");
    }
    drawText(displayCurrency(calculateTotalMonthlyExpenses(kyc), i18n.language), "totalExpenses");
    drawText(displayCurrency(calculateTotalMonthlyExpensesAfterMat(kyc), i18n.language), "totalExpensesAfterMat");
    drawText(displayCurrency(kyc.transportation, i18n.language), "transportation");
    drawText(displayCurrency(kyc.transportationAfterMat, i18n.language), "transportationAfterMat");
    drawText(displayCurrency(kyc.utilities, i18n.language), "utilities");
    drawText(displayCurrency(kyc.utilitiesAfterMat, i18n.language), "utilitiesAfterMat");
    drawText(kyc.vehicles, "vehicles");
    drawText(kyc.vehicles, "vehiclesAfterMat");
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? SKYCMaternity2FrenchLabels : SKYCMaternity2EnglishLabels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];

    const subscriber2Include = state.common.subscriber2Include;


    // s1Signature
    signers.push({
        [subscriberRecipientId]: [signatureTab(subscriberRecipientId, documentId, pageNumber, signatureLabel("s1Signature", labels))],
    });


    // drSignature
    signers.push({
        [DRRecipientId]: [signatureTab(DRRecipientId, documentId, pageNumber, signatureLabel("drSignature", labels))],
    });

    if (subscriber2Include) {
        // s2Signature
        signers.push({
            [jointSubscriberRecipientId]: [signatureTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel("s2Signature", labels))],
        });
    }

    return signers;
}

export default {
    generate,
    signatureDefinitions
}
